import React from 'react';

const Dialog: React.FC<any> = ({children, onClose}): React.ReactElement => {
	return <div style={{
		position: 'fixed',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		zIndex: 999999,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		overflow: 'hidden'
	}}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
							}}
	>
		<div style={{
			position: 'absolute',
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			zIndex: 1,
			backgroundColor: '#000',
			opacity: 0.25,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center'
		}}
				 onClick={onClose}
		>
		</div>
		<div style={{
			backgroundColor: '#FFFFFF',
			padding: '40px',
			position: 'relative',
			zIndex: 2,
		}}>
			{children}
		</div>

	</div>;
};

export default Dialog;
